import React, { Component } from 'react';
import   SideNav from "../sidenav/sidenav.js"
import "./tuition.css"
import  AuthService  from "../api/authentication.js";
import   Tuitons  from "./tuitions.js"
import  Moble from "../sidenav/moble.js"

import {
    Redirect
  } from 'react-router-dom'

//   https://uvune-events.herokuapp.com
const Auth = new AuthService();
class FormBuild extends Component {
  
    constructor(props){
        super(props)
        this.state = {
            loading : false,
            errorend  : false,
            tuitions : [],
            user : this.props.user,
            loadingTuition : false,
            editshow : false,
            loadingedit : false,
            noticeshow : false,
            noticeMassage : "",
            noerorrpage :  true,
            categories : [],
            tuitionCategory :[],
            type1:'coconut',
            sendTo : false,
            allPeople : false,
            closeAllbutton : true,
            domain: 'https://uvune-events.herokuapp.com' ,
            isActive:false           
        }
     
    }





    componentDidMount(){
        this.props.noerorrpage(this.state.noerorrpage)
        this.setState({
            loadingTuition :true,
            isActive:true
        })
        
        // console.log("get payment",  this.state.user.display_name)
        const requestOptions = {
            method: 'GET', 
            headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
          };
        fetch(this.state.domain+"/users/"+ Auth.getProfile().userId, requestOptions)
        .then(res => res.json())
        .then((result)=>{
            if(result){
                //console.log("res", result)
                fetch(this.state.domain+"/payment-item?organizers_id="+ result.organizers_id, requestOptions)
                .then(res => res.json())
                .then((result)=>{
                    if(result){
                        if(result.code === 500){
                            this.props.history.replace('/info');
                        }
                        this.setState({
                            loadingTuition :false,
                            tuitions :result.data
                        })
                    }else{
                        this.setState({
                            loadingTuition :true
                        }) 
                    }
                })

            }else{
                this.setState({
                    loadingTuition :true
                }) 
            }
        })

        }
    
     


  paymentForm  = ( event) =>{
    event.preventDefault();
    this.setState({
      loading:true,
    })
    //  console.log("data=====payment", this.name.value, this.amount.value, this.description.value,
    //   this.account_no.value,this.props.organizer._id, this.props.user._id,this.valueTK.value, )
     
     const datapayment ={
         type : "FM",
         name : this.name.value,
         description : this.description.value,
         amount : this.amount.value,
         venue: this.valueTK.value,
         owner: this.props.user._id,
         organizers_id : this.props.organizer._id,
         
     }

    //  console.log("data -----",datapayment)
     const requestOptions = {
      method: 'POST', 
      headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
      body: JSON.stringify(datapayment),
    };
    // console.log("requestOptions", requestOptions)
    fetch(this.state.domain+"/payment-item", requestOptions)
          .then(res => res.json())
          .then((result)=>{
              if(result){
                //   console.log("result", result)
                  
                  const tuitions  = this.state.tuitions
                  tuitions.push({
                      name : this.name.value,
                      description : this.description.value,
                      venue : this.valueTK.value,
                      amount : this.amount.value,
                      type : result.type,
                      createdAt: result.createdAt,
                      _id : result._id
                  })
                //   console.log("date", result.createdAt)
                  this.setState({
                      tuitions,
                      loading:false,
                      noticeshow:true,
                      noticeMassage : "Created"
                  })
                  this.timeout() 
              }
            
          }).catch( (error) => {
              //  console.log("errro", error);
            //    console.log("error load", error )
          });

          this.setState({
              loading:false ,
              noticeMassage : "Failed to create"
          })  

  }
 paymentTicket = ( event) =>{
      event.preventDefault();
      this.setState({
        loading:true,
      })
    //    console.log("data=====payment", this.name.value, this.amount.value, this.description.value,
    //     this.account_no.value,this.props.organizer._id, this.props.user._id,this.valueTK.value, )
       
       const datapayment ={
           type : "TK",
           
           name : this.name.value,
           description : this.description.value,
           amount : this.amount.value,
           venue: this.valueTK.value,
           owner: this.props.user._id,
           organizers_id : this.props.organizer._id,
           
       }
    //    console.log("data -----",datapayment)
       const requestOptions = {
        method: 'POST', 
        headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
        body: JSON.stringify(datapayment),
      };
    //   console.log("requestOptions", requestOptions)
      fetch(this.state.domain+"/payment-item", requestOptions)
            .then(res => res.json())
            .then((result)=>{
                if(result){
                    // console.log("result", result)
                    
                    const tuitions  = this.state.tuitions
                    tuitions.push({
                        name : this.name.value,
                        description : this.description.value,
                        venue : this.valueTK.value,
                        amount : this.amount.value,
                        createdAt: result.createdAt,
                        type : result.type,
                        _id : result._id
                    })
                    // console.log("date", result.createdAt)
                    this.setState({
                        tuitions,
                        loading:false,
                        noticeshow:true,
                        noticeMassage : "Created"
                    })
                    this.timeout() 
                }
              
            }).catch( (error) => {
                //  console.log("errro", error);
                //  console.log("error load", error )
            });

            this.setState({
                loading:false ,
                noticeMassage : "Failed to create"
            })  

    }

    editpayment = (data)=> {
        // event.preventDefault();  
        // console.log("data",data) 

        const dataedit ={ 
            name : data.name,
            amount : data.amount,
            description : data.description,
            tuition_category_id : data.tuition_category_id

        }

        const requestOptions = {
            method: 'PATCH', 
            headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
            body: JSON.stringify(dataedit),
          };

        //   console.log("data", requestOptions, "id", data.id)
          fetch(this.state.domain+"/payment-item/"+ data.id, requestOptions)
          .then(res => res.json())
          .then((result)=>{
            if(result){
                if(result.code === "400"){
                    //   console.log("error load", result.code )
                    this.setState({
                        loadingedit:true,
                        noticeshow : true,
                        noticeMassage : "Select category"
                    })
                        this.timeout() 
                }else{

                    // console.log("result", result)
                    this.setState({
                        loadingedit:true,
                        noticeshow : true,
                        noticeMassage : "Updated"
                    })
                    this.timeout() 

                }
              
            }
          }).catch( (error) => {
            //  console.log("errro", error);
            //  console.log("error load", error )
        });

        this.setState({
            loading:false ,
            noticeMassage : "Failed to Update"
        })  
         
    }
    onDelete = (data) => {
        const requestOptions = {
            method: 'DELETE', 
            headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
            // body: JSON.stringify(dataedit),
          };
        // console.log("dalete", data)
        fetch(this.state.domain+"/payment-item/"+ data, requestOptions)
          .then(res => res.json())
          .then((result)=>{
            if(result){
                // console.log("result", result)
                this.setState({
                    loadingedit:true,
                    noticeshow : true,
                    noticeMassage : "Delete"
                })
                this.timeout() 
                const  tuitions  = this.state.tuitions
                const fitlereddata =   tuitions .filter( tuition =>{
                    return tuition._id !== data
                  })
                // console.log(fitlereddata)
                this.setState({tuitions:fitlereddata})
            }
          }).catch( (error) => {
            //  console.log("errro", error);
            //  console.log("error load", error )
        });

        this.setState({
            loading:false ,
            noticeMassage : "Failed to Delete"
        })  
    }

    showedit = (event)=>{
        event.preventDefault();
        // console.log("show")
       this.setState({
           editshow :true
       })    
    }


    timeout() {
        setTimeout(function() {
            this.setState({
                noticeshow : false
            })
        //   console.log(this.state.noticeshow);
        }.bind(this), 4000);
    }
    
    switchFormsendTo=()=>{
        // console.log("data yes")
        this.setState({
            sendTo :true,
            allPeople: false,
            closeAllbutton : false
        })
     }
     
     switchFormToevery=()=>{
        //  console.log("data yes")
        this.setState({
            sendTo :false,
            allPeople: true,
            closeAllbutton :false
        })
     }
     
     switchFormAllclose=()=>{
         this.setState({
             sendTo :false,
             allPeople: false,
             closeAllbutton : true
         })
     }
    logout = () =>{
        // console.log("judge love")
        this.props.logout()
      }




  render() {
    //   console.log("cheking---------tui", this.props.isAuthenticated)
     return (

        this.state.submitIftrue ? (
                                
            <Redirect to={{    pathname: `${'/info'}`  }}/>

       ):
        !this.props.isAuthenticated ? (
            <div className="hero is-bold is-fullheight">
            <div className="level-item">
            <a className="button is-loading is-large is-light">Loading</a>
            </div>
            <div className="level-item">
            <span>Trying to login...</span>
            </div>
        </div>
           )
             :
            <div className="Tuition"> 
               <div className="Activity-moble-nav-body">
                    < Moble  logout={this.logout} isActiveF={this.state.isActive}/>
               </div>     
                    <SideNav vanImage={this.props.organizer.image_url}  email={this.props.user.email} 
                    logout={this.logout} name={this.props.user.first_name + " " + this.props.user.last_name} 
                    organizers404={this.props.organizers404}  isActiveF={this.state.isActive}
                    /> 

                 <div className="main"> 
                 <div className="topright">
                    {
                        this.state.noticeshow ?
                         <div className="notice-cos-tuition">
                            {this.state.noticeMassage}
                         </div> :
                         <span> </span> 
                    }
                        
                 </div>
                      <div className="tuition-home-body">   
                           
                        <div className="home"> 
                                    <br/>
                                    <article className="message is-info">
                                            <div className="message-header">
                                                <p>My Events</p>
                                                        {/* <button class="delete" aria-label="delete"></button> */}
                                            </div>
                              <div className="message-body">

                                    <div className="">  
                                     {
                                        this.state.loadingTuition ? 
                                             <div className="level-item">
                                                <a className="button is-loading is-large is-light">Loading</a>
                                            </div>
                                        :

                                             <div className="">
                                                 <ul className="responsive-table">
                                                            <li className="table-header">
                                                            <div className="col col-1">Name</div>
                                                            <div className="col col-2">Amount</div>
                                                            <div className="col col-3">Type</div>
                                                            <div className="col col-4">ACTION</div>
                                                            </li>
                                                          {
                                                                this.state.tuitions.map(tuition=>{
                                                                    //console.log("tuition now", tuition);
                                                                       return(
                                                                           
                                                                        <Tuitons
                                                                                key={ tuition._id}
                                                                                data={ tuition}
                                                                                // amount={ tuition.amount}
                                                                                // type={ tuition.type}
                                                                                // value1={ tuition.venue}
                                                                                // date={ tuition.createdAt}
                                                                                // category_id={tuition.tuition_category_id}
                                                                                // description={ tuition.description}
                                                                                submitedit={this.editpayment}
                                                                                onDelete={this.onDelete}
                                                                                id={tuition._id}
                                                                                categories={this.state.categories}
                                                                                
                                                                                
                                                                                category={tuition.category}
                                                                        />
            
                                                                       )
            
                                                                      })
                                                              }
                                                        </ul>
                                                        {
                                                        

                                                     }    
                                                  
                                                </div>

                                       }
                                        
                    
                                    </div>
                                               
                                            </div>
                                    </article>
                                    
                                   
                                    
                                   </div>    
                                </div>
                  
                </div> 
           </div>     

    )

}





}

export default FormBuild;


// WEBPACK FOOTER //
// ./src/component/form/form.js